module.exports = "/assets/d86ebcc18aed074194bfb8f88e5f1589.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/UM.png
// module id = 3015
// module chunks = 0